import { NavLink } from "react-router-dom"

const Navbar = () => {
  let activeClassName = "link active"
  return (
    <>
      <div className="text-center p-3">
        <NavLink
          to="/about"
          className={({ isActive }) => (isActive ? activeClassName : "link")}
        >
          About
        </NavLink>
        <NavLink
          to="/projects"
          className={({ isActive }) => (isActive ? activeClassName : "link")}
        >
          Projects
        </NavLink>
        <NavLink
          to="/CV"
          className={({ isActive }) => (isActive ? activeClassName : "link")}
        >
          CV
        </NavLink>
      </div>
    </>
  )
}

export default Navbar
